module.exports = __webpack_public_path__ + "img/apple.0b7e782a.svg";